// External
import { Component, Input, OnInit, HostBinding, HostListener, ElementRef} from '@angular/core';
import { trigger, state, transition, animate, style} from '@angular/animations';
import { Subject } from 'rxjs';
import { UiStepsComponent } from './ui-steps.component';

// Internal
export const AnimationDuration = 400;
// for content fade
// <div class="step-content" @contentFade *ngIf="index === this.flowActiveStep"><ng-content></ng-content></div>
@Component({
    selector: 'step, [step]',
    template: `<div class="step-content" @contentFade *ngIf="index === flowActiveStep"><ng-content></ng-content></div>`,
    host: {
        '[class.step]':'true'
    },
    animations: [
        trigger('stepSlide', [   
            state('in', style({  transform: 'translateX(0)', position: 'static'})),
            state('left', style({ transform: 'translateX(-100%)', position: 'absolute'})),
            state('right', style({ transform: 'translateX(100%)', position: 'absolute'})),

            transition('right => in', [
                style({transform: 'translateX(100%)', height: '100%'}),
                animate(AnimationDuration, style({transform: 'translateX(0%)'})),                
            ]),
            transition('in => left', [               
                style({transform: 'translateX(0)'}),
                animate(AnimationDuration, style({transform: 'translateX(-100%)', opacity: 0})),            
            ]),
            transition('left => in', [               
                style({transform: 'translateX(-100%)', height: '100%'}),
                animate(AnimationDuration, style({transform: 'translateX(0%)'})),               
            ]),           
            transition('in => right', [              
                style({transform: 'translateX(0)'}),
                animate(AnimationDuration, style({transform: 'translateX(100%)', opacity: 0})),              
            ])
        ]),
        // this is buggy must check it out
        trigger('contentFade', [    
            // no need for enter animation, we want the content to be available right away 
            transition(':enter', [
                // style({opacity: 0}),
                // animate('150ms', style({opacity: 1}))
            ]),
            transition(':leave', [
                // style({opacity: 1}),
                // animate('150ms 15000ms', style({opacity: 0}))
            ])            
        ])             
    ]
})

export class StepComponent implements OnInit {

    // index of this step in a defined flow, for undefined flow (self-generated) index is not required
    @Input() index: number;  
    flowActiveStep = 0;

    animationPreventedEvents = ['keydown', 'click'];
    
    private onDestroy$: Subject<void> = new Subject<void>();
    
    constructor(private stepper: UiStepsComponent, private el: ElementRef) {
        stepper.addStep(this);
    }

    ngOnInit() {    
    }

    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    // deciding step direction
    @HostBinding('@stepSlide') get slide() {              
      
        this.flowActiveStep =  this.stepper.flow[this.stepper.activeStepIndex];
        if(this.index ===  this.flowActiveStep) {
            return 'in'
        }
        else if(this.flowActiveStep > this.index) {
            return 'left'
        }
        else {
            return 'right'
        }
    }
    
    // Event preventing functions and listeners
    @HostListener('@stepSlide.start', ['$event']) startPreventingEvents(): void {
        this.animationPreventedEvents.forEach(ev => 
            this.el.nativeElement.addEventListener(ev, this.preventEvent, true)
        );
    }
    
    @HostListener('@stepSlide.done', ['$event']) stopPreventingEventsmDone(): void {
        this.animationPreventedEvents.forEach(ev => 
            this.el.nativeElement.removeEventListener(ev, this.preventEvent, true)
        );
    }
    
    preventEvent(event) {
        event.stopPropagation();
        event.preventDefault();
    }

}
